var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.707 214.5 279.291C275.856 355.626 338.19 411.736 396 452.358V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.823 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0AA2C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0426 41.1818H73.5199L94.2472 91.7727H95.0653L115.793 41.1818H131.27V111H119.134V63.0341H118.486L99.1903 110.795H90.1222L70.8267 62.9318H70.179V111H58.0426V41.1818ZM182.986 60.375C182.668 57.3977 181.327 55.0795 178.963 53.4205C176.622 51.7614 173.577 50.9318 169.827 50.9318C167.19 50.9318 164.929 51.3295 163.043 52.125C161.156 52.9205 159.713 54 158.713 55.3636C157.713 56.7273 157.202 58.2841 157.179 60.0341C157.179 61.4886 157.509 62.75 158.168 63.8182C158.849 64.8864 159.77 65.7955 160.929 66.5455C162.088 67.2727 163.372 67.8864 164.781 68.3864C166.19 68.8864 167.611 69.3068 169.043 69.6477L175.588 71.2841C178.224 71.8977 180.759 72.7273 183.19 73.7727C185.645 74.8182 187.838 76.1364 189.77 77.7273C191.724 79.3182 193.27 81.2386 194.406 83.4886C195.543 85.7386 196.111 88.375 196.111 91.3977C196.111 95.4886 195.065 99.0909 192.974 102.205C190.884 105.295 187.861 107.716 183.906 109.466C179.974 111.193 175.213 112.057 169.622 112.057C164.19 112.057 159.474 111.216 155.474 109.534C151.497 107.852 148.384 105.398 146.134 102.17C143.906 98.9432 142.702 95.0114 142.52 90.375H154.963C155.145 92.8068 155.895 94.8295 157.213 96.4432C158.531 98.0568 160.247 99.2614 162.361 100.057C164.497 100.852 166.884 101.25 169.52 101.25C172.27 101.25 174.679 100.841 176.747 100.023C178.838 99.1818 180.474 98.0227 181.656 96.5455C182.838 95.0455 183.44 93.2955 183.463 91.2955C183.44 89.4773 182.906 87.9773 181.861 86.7955C180.815 85.5909 179.349 84.5909 177.463 83.7955C175.599 82.9773 173.418 82.25 170.918 81.6136L162.974 79.5682C157.224 78.0909 152.679 75.8523 149.338 72.8523C146.02 69.8295 144.361 65.8182 144.361 60.8182C144.361 56.7045 145.474 53.1023 147.702 50.0114C149.952 46.9205 153.009 44.5227 156.872 42.8182C160.736 41.0909 165.111 40.2273 169.997 40.2273C174.952 40.2273 179.293 41.0909 183.02 42.8182C186.77 44.5227 189.713 46.8977 191.849 49.9432C193.986 52.9659 195.088 56.4432 195.156 60.375H182.986ZM220.034 41.1818V111H207.386V41.1818H220.034Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.813 400.5C129.556 400.5 127.689 399.762 126.214 398.286C124.738 396.811 124 394.944 124 392.688C124 390.431 124.738 388.564 126.214 387.089C127.689 385.613 129.556 384.875 131.813 384.875H345.354C347.611 384.875 349.477 385.613 350.953 387.089C352.429 388.564 353.167 390.431 353.167 392.688C353.167 394.944 352.429 396.811 350.953 398.286C349.477 399.762 347.611 400.5 345.354 400.5H131.813ZM150.042 369.25C145.875 369.25 142.229 367.687 139.104 364.562C135.979 361.437 134.417 357.792 134.417 353.625V228.625C134.417 224.458 135.979 220.813 139.104 217.688C142.229 214.563 145.875 213 150.042 213H327.125C331.292 213 334.937 214.563 338.062 217.688C341.187 220.813 342.75 224.458 342.75 228.625V353.625C342.75 357.792 341.187 361.437 338.062 364.562C334.937 367.687 331.292 369.25 327.125 369.25H150.042ZM150.042 353.625H327.125V228.625H150.042V353.625ZM150.042 353.625V228.625V353.625Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.5 424C180.018 424 208 396.018 208 361.5C208 326.982 180.018 299 145.5 299C110.982 299 83 326.982 83 361.5C83 396.018 110.982 424 145.5 424ZM145.5 377.5C154.337 377.5 161.5 370.337 161.5 361.5C161.5 352.663 154.337 345.5 145.5 345.5C136.663 345.5 129.5 352.663 129.5 361.5C129.5 370.337 136.663 377.5 145.5 377.5Z",
    fill: "#0DCAF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.5 361.5C129.5 357.389 131.05 353.64 133.598 350.806L100.075 318.572C89.4901 329.768 83 344.876 83 361.5C83 396.018 110.982 424 145.5 424C147.52 424 149.518 423.904 151.49 423.717L147.033 377.427C146.529 377.475 146.017 377.5 145.5 377.5C136.663 377.5 129.5 370.337 129.5 361.5ZM157.033 372.59L190.552 404.819C201.357 393.585 208 378.318 208 361.5C208 326.982 180.018 299 145.5 299C143.455 299 141.433 299.098 139.439 299.29L143.895 345.579C144.423 345.527 144.958 345.5 145.5 345.5C154.337 345.5 161.5 352.663 161.5 361.5C161.5 365.805 159.799 369.714 157.033 372.59Z",
    fill: "#0AA2C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 361.5,
    r: 16,
    fill: "#FAFAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_516",
    x: 46.043,
    y: 40.2266,
    width: 177.992,
    height: 87.832,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_516",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsi);
export default __webpack_public_path__ + "static/media/msi.c5a49a593d9e17d12f201b6e7dc9792b.svg";
export { ForwardRef as ReactComponent };